<template>
  <div class="lv-popup-scroll-content">
    <perfect-scrollbar class="ps lv-popup-scroll-content_scroll-content">
      <LlState
        v-model="searchInput.value"
        type="search"
        :placeholder="searchInput.placeholder"
      />
      <div class="lv-popup-scroll-content_scroll-content-list">
        <TextWithIconButton
          v-for="(item,itemIndex) in _itemList"
          :key="itemIndex"
          :text="item.text"
          :button-list="_buttonList"
          @btn-click="$_btnClick($event,item)"
        />
      </div>
      <LlEmptyPic
        v-if="!_itemList || !_itemList.length"
        :title="$t(emptyTitle)"
        :image="require('@/assets/image/img-empty/Blue-file-empty.png')"
      />
    </perfect-scrollbar>
  </div>
</template>
<script>
export default {
  name: "LvPopupScrollContent",
  props: {
    itemList: {
      type: Array,
      default() {
        return [];
      },
    },
    isUpdatable: {
      type: Boolean,
      default: false,
    },
    isDeletable: {
      type: Boolean,
      default: false,
    },
    emptyTitle: {
      type: String,
      default: '目前尚無資料',
    }
  },
  data() {
    return {
      searchInput: {
        placeholder: this.$t("搜尋"),
        value: "",
      },
    };
  },
  computed: {
    _buttonList() {
      const buttonList = []
      if (this.isUpdatable) {
        buttonList.push({
          icon: "icon-edit-pencil",
          value: "edit",
        })
      }
      if (this.isDeletable) {
        buttonList.push({
          icon: "icon-delete",
          value: "delete",
          color: "red",
        })
      }
      return buttonList
    },
    _itemList() {
      return this.itemList.filter(item => item.text.includes(this.searchInput.value))
    }
  },
  methods: {
    $_btnClick($event, item) {
      if ($event === "edit") {
        this.$emit("edit-click", item.value);
      } else if ($event === "delete") {
        this.$emit("delete-click", item.value);
      }
    },
  },
};
</script>